import React from "react";
import Header from "../Header";
import BaseContainerDividingLineRHSSidebar from "../BaseContainerDividingLineRHSSidebar";
import ExpenseBreakdownButton from "../ExpenseBreakdownButton";
import TotalExpensesButton from "../TotalExpensesButton";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import rect6451 from "../../img/rectangle-6518@2x.svg"
import vect9 from "../../img/vector-9@2x.svg"
// import { ExpenseListContext } from "../Expenses";
import axios from "axios";
import "./ExpenseBreakdownPage.css";


const ExpenseBreakdownPage = () => {

    // console.log('HERE', ExpenseListContext)

    return (
        <div className="container-center-horizontal">
            <div className="expenses-breakdown-home-page screen">
                <div className="flex-col-21">
                    <Header />
                    <div className="overlap-group6">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="expenses-17 nunito-bold-black-30px">Expenses</div>
                        <div className="rectangle-6440 border-1px-athens-gray-2"></div>
                        <div className="change-plan total-after-tax-expenses">
                            <div className="change-plan-1 nunito-bold-black-20px">Expense Breakdown</div>
                        </div>
                        <img className="rect6451" src={rect6451} />
                        <div className="rectangle-6452-2 border-1px-athens-gray-2"></div>
                        
                        <BackButton backPage="/expenses" />
                        <NextButton nextPage="/lifestrategy" />
                        <TotalExpensesButton />
                        <ExpenseBreakdownButton className="nunito-bold-azure-radiance-14px" logo={vect9} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ExpenseBreakdownPage;